var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('work_login_04',{attrs:{"namespace":"common"}},[_vm._v("登陆")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./build/vue-loader/lib/template-compiler?{"id":"data-v-550f03a6","hasScoped":false,"buble":{"transforms":{}}}!./build/vue-loader/lib/selector.js?type=template&index=0!./src/projects/huayu/components/common/header.vue
// module id = null
// module chunks = 